module.exports = __webpack_public_path__ + "static/media/Oaktree---school-professional---illsutration---Medium.92c6b9c4.svg";